(function () {
  'use strict';
  if (window.__pgReviewBubbles || !window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
  window.__pgReviewBubbles = true;
  var stages = new Map(), active = null, photoActive = null, scrollLocks = 0, rootStyles;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var locale = document.documentElement.lang || 'en';
  var relative = new Intl.RelativeTimeFormat(locale, {numeric: 'always'});
  var exact = new Intl.DateTimeFormat(locale, {year: 'numeric', month: 'short', day: 'numeric'});

  function updateDate(card) {
    var time = card.querySelector('time');
    if (!time) return;
    var date = new Date(time.dateTime), elapsed = Date.now() - date.getTime();
    time.hidden = !Number.isFinite(elapsed);
    if (time.hidden) return;
    var label = exact.format(date);
    time.title = label;
    if (elapsed >= 0 && elapsed < 30 * 86400000) {
      var unit = elapsed >= 86400000 ? 'day' : elapsed >= 3600000 ? 'hour' : 'minute';
      var amount = Math.floor(elapsed / (unit === 'day' ? 86400000 : unit === 'hour' ? 3600000 : 60000));
      label = amount ? relative.format(-amount, unit) : new Intl.RelativeTimeFormat(locale, {numeric: 'auto'}).format(0, 'second');
    }
    if (time.textContent !== label) time.textContent = label;
  }

  function lockScroll() {
    var root = document.documentElement;
    if (scrollLocks++ === 0) {
      rootStyles = {overflow: root.style.overflow, gutter: root.style.scrollbarGutter};
      var gutter = getComputedStyle(root).scrollbarGutter;
      if (!gutter || gutter === 'auto') root.style.scrollbarGutter = 'stable';
      root.style.overflow = 'hidden';
    }
  }

  function unlockScroll() {
    if (--scrollLocks !== 0) return;
    document.documentElement.style.overflow = rootStyles.overflow;
    document.documentElement.style.scrollbarGutter = rootStyles.gutter;
  }

  function enhance(stage) {
    stage.querySelectorAll('[data-review-photo-src]').forEach(function (button) { button.disabled = false; });
    stage.querySelectorAll('[data-review-id]').forEach(function (card) {
      var button = card.querySelector('[data-review-expand]'), body = card.querySelector('[data-review-body]');
      if (!button || !body) return;
      card.setAttribute('data-review-expand-ready', '');
      button.hidden = false;
      updateDate(card);
      var label = body.scrollHeight > body.clientHeight + 1 ? button.dataset.readMore : button.dataset.readReview;
      if (button.textContent !== label) button.textContent = label;
    });
  }

  function toggleStage(stage, open) {
    if (open) stage.dataset.reviewOpen = 'true';
    else delete stage.dataset.reviewOpen;
    stage.dispatchEvent(new CustomEvent('pg:review-toggle'));
  }

  function closePhoto() { if (photoActive) photoActive.dialog.close(); }

  function openPhoto(trigger, stage) {
    if (photoActive || (active && active.closing)) return;
    var url;
    try { url = new URL(trigger.dataset.reviewPhotoSrc); } catch (_) { return; }
    if (url.protocol !== 'https:' || url.username || url.password) return;
    var labels = (active && active.stage === stage ? active.card : trigger.closest('[data-review-id]')).querySelector('[data-review-expand]');
    var dialog = document.createElement('dialog');
    dialog.className = 'pg-review-photo-dialog';
    dialog.setAttribute('aria-label', trigger.getAttribute('aria-label'));
    dialog.setAttribute('aria-busy', 'true');
    var panel = document.createElement('div'); panel.className = 'pg-review-photo-dialog__panel';
    var close = document.createElement('button');
    close.type = 'button'; close.className = 'pg-review-dialog__close'; close.autofocus = true;
    close.setAttribute('data-review-photo-close', ''); close.setAttribute('aria-label', labels.dataset.closeLabel); close.textContent = '×';
    var preview = trigger.querySelector('img').cloneNode(true);
    preview.className = 'pg-review-photo-dialog__preview'; preview.alt = ''; preview.setAttribute('aria-hidden', 'true');
    var image = document.createElement('img'); image.setAttribute('data-review-original', '');
    image.alt = trigger.querySelector('img').alt; image.decoding = 'async'; image.hidden = true;
    var status = document.createElement('p'); status.className = 'pg-review-photo-dialog__status'; status.setAttribute('role', 'status');
    image.addEventListener('load', function () { dialog.setAttribute('aria-busy', 'false'); image.hidden = false; preview.hidden = true; });
    image.addEventListener('error', function () {
      dialog.setAttribute('aria-busy', 'false'); image.hidden = true;
      status.textContent = labels.dataset.photoErrorLabel;
    });
    panel.append(preview, image, close, status); dialog.appendChild(panel); document.body.appendChild(dialog);
    var state = {dialog: dialog, stage: stage, trigger: trigger}; photoActive = state;
    lockScroll(); toggleStage(stage, true);
    close.addEventListener('click', closePhoto);
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); closePhoto(); });
    var backdropDown = false;
    function isBackdrop(event) { return event.target === dialog || event.target === panel; }
    dialog.addEventListener('pointerdown', function (event) { backdropDown = isBackdrop(event); });
    dialog.addEventListener('click', function (event) { if (isBackdrop(event) && backdropDown) closePhoto(); });
    dialog.addEventListener('close', function () {
      dialog.remove(); photoActive = null; unlockScroll();
      if (stage.isConnected && !(active && active.closing)) {
        var target = trigger.isConnected ? trigger : stage.querySelector('[data-review-photo-src]:not(:disabled)');
        if (target) target.focus({preventScroll: true});
      }
      toggleStage(stage, Boolean(active && active.stage === stage));
    }, {once: true});
    dialog.showModal(); image.src = url.href;
  }

  function sourceTransform(card, panel) {
    var from = card.getBoundingClientRect(), to = panel.getBoundingClientRect();
    if (!from.width || !from.height || !to.width || !to.height) return 'translateY(24px) scale(.9)';
    return 'translate(' + (from.left + from.width / 2 - to.left - to.width / 2) + 'px,' +
      (from.top + from.height / 2 - to.top - to.height / 2) + 'px) scale(' + from.width / to.width + ',' + from.height / to.height + ')';
  }

  function dismiss() {
    if (!active || active.closing) return;
    var state = active;
    state.closing = true;
    closePhoto();
    if (state.animation) state.animation.cancel();
    state.dialog.classList.add('is-closing');
    if (reduced.matches || !state.panel.animate) { state.dialog.close(); return; }
    var animation = state.panel.animate([
      {transform: 'none', opacity: 1},
      {transform: sourceTransform(state.card, state.panel), opacity: 0}
    ], {duration: 260, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards'});
    state.animation = animation;
    animation.onfinish = function () { state.dialog.close(); };
  }

  function open(card) {
    if (active || photoActive) return;
    var stage = card.closest('[data-feedback-v3]'), trigger = card.querySelector('[data-review-expand]');
    updateDate(card);
    var dialog = document.createElement('dialog');
    dialog.className = 'pg-review-dialog';
    dialog.setAttribute('aria-label', trigger.getAttribute('aria-label'));
    var panel = document.createElement('div');
    panel.className = 'pg-review-dialog__bubble';
    panel.style.setProperty('--review-star-color', getComputedStyle(card.querySelector('.pg-stars')).color);
    dialog.style.fontFamily = getComputedStyle(card).fontFamily;
    var close = document.createElement('button');
    close.type = 'button'; close.className = 'pg-review-dialog__close';
    close.setAttribute('data-review-close', ''); close.setAttribute('aria-label', trigger.dataset.closeLabel);
    close.textContent = '×'; close.autofocus = true;
    var content = card.cloneNode(true);
    content.className = 'pg-review-expanded';
    content.tabIndex = 0;
    content.removeAttribute('style'); content.removeAttribute('id'); content.removeAttribute('hidden');
    content.removeAttribute('data-feedback'); content.removeAttribute('data-review-expand-ready');
    content.removeAttribute('aria-hidden'); content.removeAttribute('inert');
    content.querySelector('[data-review-expand]').remove();
    var tail = content.querySelector('.r2-story__review-arrow');
    if (tail) {
      tail.className = 'pg-review-dialog__tail';
      if (card.classList.contains('v3-feedback-cloud--1')) tail.classList.add('pg-review-dialog__tail--right');
      if (card.classList.contains('v3-feedback-cloud--2')) tail.classList.add('pg-review-dialog__tail--top');
      panel.appendChild(tail);
    }
    panel.append(close, content); dialog.appendChild(panel); document.body.appendChild(dialog);
    var state = {dialog: dialog, panel: panel, card: card, stage: stage, trigger: trigger,
      closing: false};
    active = state;
    toggleStage(stage, true);
    lockScroll();
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); dismiss(); });
    close.addEventListener('click', dismiss);
    var backdropDown = false;
    dialog.addEventListener('pointerdown', function (event) { backdropDown = event.target === dialog; });
    dialog.addEventListener('click', function (event) { if (event.target === dialog && backdropDown) dismiss(); });
    dialog.addEventListener('close', function () {
      if (state.animation) state.animation.cancel();
      closePhoto();
      dialog.remove(); active = null;
      unlockScroll();
      toggleStage(stage, Boolean(photoActive && photoActive.stage === stage));
      var target = trigger.isConnected && card.getClientRects().length ? trigger :
        stage.querySelector('[data-review-id]:not([hidden]) [data-review-expand]');
      if (target) target.focus({preventScroll: true});
    }, {once: true});
    dialog.addEventListener('click', function (event) {
      var photo = event.target.closest('[data-review-photo-src]');
      if (photo) openPhoto(photo, stage);
    });
    dialog.showModal();
    if (!reduced.matches && panel.animate) {
      state.animation = panel.animate([
        {transform: sourceTransform(card, panel), opacity: .35, offset: 0},
        {transform: 'scale(1.035)', opacity: 1, offset: .72},
        {transform: 'scale(.99)', opacity: 1, offset: .88},
        {transform: 'none', opacity: 1, offset: 1}
      ], {duration: 540, easing: 'cubic-bezier(.22,.7,.25,1)'});
    }
  }

  function scan() {
    document.querySelectorAll('[data-feedback-v3]').forEach(function (stage) {
      if (stages.has(stage)) return;
      enhance(stage);
      // A carousel initialized first may have measured the full, unclamped quotes.
      stage.dispatchEvent(new CustomEvent('pg:reviews-ready'));
      function updated() {
        enhance(stage);
        stage.dispatchEvent(new CustomEvent('pg:reviews-ready'));
      }
      stage.addEventListener('pg:reviews-updated', updated);
      var frame;
      function refresh() { cancelAnimationFrame(frame); frame = requestAnimationFrame(function () { enhance(stage); }); }
      var mutations = new MutationObserver(refresh);
      mutations.observe(stage, {childList: true});
      var resize = window.ResizeObserver ? new ResizeObserver(refresh) : null;
      if (resize) resize.observe(stage);
      if (document.fonts) document.fonts.ready.then(refresh);
      function clicked(event) {
        var photo = event.target.closest('[data-review-photo-src]');
        if (photo) { openPhoto(photo, stage); return; }
        var card = event.target.closest('[data-review-expand-ready]');
        if (!card || event.target.closest('a,.pg-judgeme-photo,.pg-review-media') || window.getSelection().toString()) return;
        open(card);
      }
      stage.addEventListener('click', clicked);
      stages.set(stage, function () { mutations.disconnect(); if (resize) resize.disconnect(); cancelAnimationFrame(frame); stage.removeEventListener('pg:reviews-updated', updated); stage.removeEventListener('click', clicked); });
    });
  }
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', function (event) {
    if (photoActive && event.target.contains(photoActive.stage)) closePhoto();
    if (active && event.target.contains(active.stage)) active.dialog.close();
    stages.forEach(function (cleanup, stage) { if (event.target.contains(stage)) { cleanup(); stages.delete(stage); } });
  });
  // Keep visible ages current without accumulating timers per bubble or clone.
  setInterval(function () { stages.forEach(function (_, stage) { if (stage.isConnected) enhance(stage); }); if (active) updateDate(active.panel); }, 60000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once: true});
  else scan();
}());
